if (!customElements.get('hero-inspiration-link')) {
  customElements.define('hero-inspiration-link', class extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
      this.scrollToGallery = this.scrollToGallery.bind(this);
    }

    connectedCallback() {
      this.update();
      this.addEventListener('click', this.scrollToGallery);
      document.addEventListener('shopify:section:load', this.update);
      document.addEventListener('shopify:section:unload', this.update);
      document.addEventListener('shopify:section:reorder', this.update);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.scrollToGallery);
      document.removeEventListener('shopify:section:load', this.update);
      document.removeEventListener('shopify:section:unload', this.update);
      document.removeEventListener('shopify:section:reorder', this.update);
    }

    scrollToGallery(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a');
      const hash = link?.getAttribute('href');
      if (!hash?.startsWith('#')) return;

      const gallery = document.getElementById(hash.slice(1));
      if (!gallery) return;

      event.preventDefault();
      if (window.location.hash !== hash) window.history.pushState(null, '', hash);
      gallery.focus({ preventScroll: true });
      gallery.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start'
      });
    }

    update(event) {
      const link = this.querySelector('a');
      if (!link) return;

      // Shopify fires unload before removing a section from the document.
      const unloading = event?.type === 'shopify:section:unload' ? event.target : null;
      const gallery = Array.from(document.querySelectorAll('#MainContent [data-room-inspiration]'))
        .find((element) => element.id && !unloading?.contains(element));

      this.hidden = !gallery;
      if (gallery) {
        link.setAttribute('href', `#${gallery.id}`);
      } else {
        link.removeAttribute('href');
      }
    }
  });
}
